module.exports = __webpack_public_path__ + "img/06_food5.4ecc4675.png";